<template>
<svg viewBox="0 0 16 16" :fill="useCurrentColor ? 'currentColor' : '#000'" xmlns="http://www.w3.org/2000/svg" :class="[`${prefix}-icon`, `${prefix}-icon-line-close-2`]" width="1em" height="1em" v-bind="$attrs"><g clip-path="url(#svg_716f6b3059__clip0_5917_20465)"><path fill-rule="evenodd" clip-rule="evenodd" d="M7.99466 7.37501L10.1945 5.17512C10.3681 5.00155 10.6495 5.00155 10.8231 5.17512C10.9967 5.34869 10.9967 5.63009 10.8231 5.80366L8.6232 8.00355L10.8231 10.2034C10.9967 10.377 10.9967 10.6584 10.8231 10.832C10.6495 11.0055 10.3681 11.0055 10.1945 10.832L7.99466 8.63209L5.79477 10.832C5.6212 11.0055 5.3398 11.0055 5.16623 10.832C4.99267 10.6584 4.99267 10.377 5.16623 10.2034L7.36612 8.00355L5.16623 5.80366C4.99267 5.63009 4.99267 5.34869 5.16623 5.17512C5.3398 5.00155 5.6212 5.00155 5.79477 5.17512L7.99466 7.37501Z"/><path d="M8.00003 14.2222C11.4365 14.2222 14.2222 11.4365 14.2222 8.00003C14.2222 4.56359 11.4365 1.7778 8.00003 1.7778C4.56359 1.7778 1.7778 4.56359 1.7778 8.00003C1.7778 11.4365 4.56359 14.2222 8.00003 14.2222ZM8.00003 15.1111C4.07267 15.1111 0.888916 11.9274 0.888916 8.00003C0.888916 4.07267 4.07267 0.888916 8.00003 0.888916C11.9274 0.888916 15.1111 4.07267 15.1111 8.00003C15.1111 11.9274 11.9274 15.1111 8.00003 15.1111Z"/></g><defs><clipPath id="svg_716f6b3059__clip0_5917_20465"><path d="M0 0H16V16H0z"/></clipPath></defs></svg>
</template>
<script>

export default {
  name: 'IconLineClose2',
  props: {
    prefix: {
        type: String,
        default: 'sc',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
